module.exports = __webpack_public_path__ + "img/play-naranja.ba610311.svg";